<template lang="pug">
  div
    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)")
      tr(slot="thead")
        th Code
        th Business step
        th Disposition
        th Event time
        th Location
        th Package
        th Product
      tr(v-for="e in events")
        td
          a.kzcode-default(@click="goToCode(e.code.code)") {{e.code.code}}
        td {{e.bizStep | bizStep}}
        td {{e.disposition | disposition}}
        td {{e.timestamp | date}}
        td {{e.location.name}}
        td(@click="goToPackage(e.packageType.id)")
          a(v-if="e.packageType") {{e.packageType.name}}
        td(@click="goToProduct(e.product.id)")
          a(v-if="e.product") {{e.product.name}}


</template>

<script>
import TrackNTrace from '@/service/apis/TrackNTrace'
import DataGrid from '@/components/ssp/DataGrid'
import { dateFilter } from '@/filters/filters'
import { bizStepFilter, dispositionFilter } from '@/components/pages/trackntrace/utils'

export default {
  props: ['filter'],
  data() {
    return {
      events: []
    }
  },
  methods: {
    fetchData(pg) {
      const req = pg.pageSizeOffsetRequest()
      req.endDate = this.filter.endDate
      req.startDate = this.filter.startDate

      return TrackNTrace.getEvents(req)
        .then((resp) => {
          this.events = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => { this.$emit('error', e) })
    },
    goToCode(code) {
      this.$router.push(`/trackntrace/dashboards/trace/${code}`)
    },
    goToProduct(id) {
      this.$router.push(`/core/configuration/product/${id}`)
    },
    goToPackage(id) {
      this.$router.push(`/trackntrace/configuration/packages/${id}`)
    }
  },
  watch: {
    filter: {
      handler() {
        this.$refs.grid.reload(true)
      },
      deep: true
    },
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter,
    disposition: dispositionFilter,
    bizStep: bizStepFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/components/LastEvents.vue